"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_2 = require("react");
var useWidgetContext_1 = require("../../react/useWidgetContext");
var singpass_1 = require("../../constants/singpass");
var assetManager_1 = require("../../../../../common/service/assetManager");
var constants_1 = require("../../constants/constants");
var errorHandler_1 = require("../../service/errorHandler");
var useUrlDealId_1 = require("../../../gql/common/hooks/useUrlDealId");
var SingpassDxp = react_1.forwardRef(function (_a, ref) {
    var setLoadingStatus = _a.setLoadingStatus;
    var widgetId = react_1.useMemo(function () { return 'dxp-singpass-container' + Math.floor(Math.random() * 100); }, []);
    var widgetInstance = react_1.useRef(null);
    var singpassLibrary = react_1.useRef(null);
    var configuration = useWidgetContext_1.default().configuration;
    var dealId = useUrlDealId_1.default();
    var ensureLibraryLoaded = function () {
        var widgetUrl = singpass_1.SINGPASS_CONFIG.dxpWidgetUrl;
        if (assetManager_1.assetManager.isScriptLoaded(widgetUrl)) {
            if (!singpassLibrary.current && window.DXPSingpass) {
                singpassLibrary.current = window.DXPSingpass;
            }
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(function () {
            // keep in mind there's a slight difference between the react versions of dxp and auto-widgets
            if (!assetManager_1.assetManager.isScriptLoaded(constants_1.default.REACT_DEPENDENCIES.react18)) {
                return assetManager_1.assetManager
                    .loadScript(constants_1.default.REACT_DEPENDENCIES.react18)
                    .then(function () { return assetManager_1.assetManager.loadScript(constants_1.default.REACT_DEPENDENCIES.reactDom18); });
            }
        })
            .then(function () { return assetManager_1.assetManager.loadScript(widgetUrl, 'module'); })
            .then(function () {
            singpassLibrary.current = window.DXPSingpass;
        });
    };
    var getLibrary = react_1.useCallback(function () {
        if (!singpassLibrary.current) {
            throw new Error("Attempted to use DXP Singpass library without loading it first");
        }
        return singpassLibrary.current;
    }, [singpassLibrary.current]);
    var initializeWidget = function () {
        if (widgetInstance.current) {
            widgetInstance.current.destroy();
        }
        setLoadingStatus(true);
        var widgetConfig = {
            containerId: widgetId,
            cookieDomain: process.env.REACT_APP_SESSION_COOKIE_DOMAIN,
            dealId: dealId,
        };
        if (configuration.cookieDomain) {
            widgetConfig.cookieDomain = configuration.cookieDomain;
        }
        var dxpWidget = getLibrary();
        dxpWidget.createWidget(widgetConfig);
    };
    react_1.useEffect(function () {
        if (!widgetInstance.current) {
            ensureLibraryLoaded()
                .then(function () { return initializeWidget(); })
                .catch(errorHandler_1.default.promise())
                .finally(function () { return setLoadingStatus(false); });
        }
        return function () {
            if (widgetInstance.current) {
                widgetInstance.current.destroy();
            }
        };
    }, []);
    return <div ref={ref} id={widgetId} data-test={'checkout:singpass:root'}/>;
});
exports.default = SingpassDxp;
